export const GET_CUSTOMER_BY_EMAIL_SUCCESS = "GET_CUSTOMER_BY_EMAIL_SUCCESS";
export const GET_CUSTOMER_BY_EMAIL_FAILURE = "GET_CUSTOMER_BY_EMAIL_FAILURE";
export const GET_ALL_CUSTOMER_MOCKS = "GET_ALL_CUSTOMER_MOCKS";
export const CREATE_CUSTOMER = "CREATE_CUSTOMER";
export const CREATE_PARENT_MOCK = "CREATE_PARENT_MOCK";
export const DELETE_MOCK = "DELETE_MOCK";
export const CURRENT_USER_DETAILS = "CURRENT_USER_DETAILS";
export const RESET_ALL_STORE_DATA = "RESET_ALL_STORE_DATA";
